import React from "react";
import Organic from "../../images/onMarketplace-benefits-icon/organic.svg";
import Tracable from "../../images/onMarketplace-benefits-icon/traceability-provenance.svg";
import ProductListing from "../../images/onMarketplace-benefits-icon/product-listing.svg";

import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function PartnerBenefits() {
  const benefits = [
    {
      img: Organic,
      title: "Enhanced Security & Access Control",
      bodycopy:
        " Ensures secure identity management and implements role-based access control (RBAC) across all services to protect sensitive data.  ",
    },
    {
      img: Tracable,
      title: "Efficient Business Registration & Onboarding",
      bodycopy:
        " Streamlines the user and business onboarding process with automated registration services, reducing manual effort and time. ",
    },

    {
      img: ProductListing,
      title: "Improved Asset Lifecycle Management",
      bodycopy:
        " Provides real-time visibility into asset status, usage, and maintenance schedules, optimizing asset performance and reducing downtime. ",
    },
    {
      img: ProductListing,
      title: "Seamless Integration with Blockchain",
      bodycopy:
        "Enables secure, transparent, and immutable transactions for both financial and business operations, enhancing trust and accountability.",
    },

    {
      img: ProductListing,
      title: "Scalable Microservices for Enterprise Growth",
      bodycopy:
        " Allows businesses to scale dynamically, ensuring high performance, reliability, and adaptability as the enterprise grows.",
    },
    {
      img: ProductListing,
      title: "Faster Transactions & Order Processing",
      bodycopy:
        "Speeds up order placements, approvals, and fulfillment through the use of efficient order proxies and adapters, ensuring quicker transactions.",
    },
    {
      img: ProductListing,
      title: "Cost-Effective Cloud Services",
      bodycopy:
        "Reduces operational costs by leveraging efficient cloud-based service gateways and storage solutions, optimizing resource usage.",
    },
    {
      img: ProductListing,
      title: "Intelligent Data Analytics & Reporting",
      bodycopy:
        "Utilizes analytics servers and insights management tools to drive better decision-making, improve operational efficiency, and enhance business intelligence.",
    },
    {
      img: ProductListing,
      title: "Simplified Device & IoT Management",
      bodycopy:
        "Enables easy onboarding, monitoring, and lifecycle tracking of devices through secure and efficient device management services.",
    },
    {
      img: ProductListing,
      title: "Automated Financial Transactions & Wallet Services",
      bodycopy:
        "Provides secure and seamless financial services, supporting wallet integration and blockchain-backed transactions for faster and safer payments.",
    },

    {
      img: ProductListing,
      title: "Centralized Content & Document Management",
      bodycopy:
        "Streamlines document storage, generation, and billing services, improving overall document workflow and reducing administrative overhead.",
    },
    {
      img: ProductListing,
      title: "Higher Operational Efficiency with Proxy Services",
      bodycopy:
        "Enhances data routing, security, and scalability using secure API gateways, leading to more efficient and reliable operations.",
    },

    {
      img: ProductListing,
      title: "Improved Customer Experience & Partner Collaboration",
      bodycopy:
        "Empowers partners to customize solutions, manage data, and offer improved services, enhancing collaboration and customer satisfaction. ",
    },

    {
      img: ProductListing,
      title: "Compliance & Regulatory Adherence",
      bodycopy:
        "Ensures data privacy, regulatory compliance, and financial security through robust secure authentication services, safeguarding the enterprise and its users.",
    },
  ];
  return (
    <div className="">
      <Container className=" subSectionWrapper">
        <h2 className="text-center container-title mb-4">Benefits</h2>
        <Row>
          {benefits.map((e,index) => {
            return (
              <Col md={4} className="d-flex" key={index}>
                <BenefitsCard
                  src={e.img}
                  title={e.title}
                  bodycopy={e.bodycopy}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}
